/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import { faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Edit, Lock, Radio, Save, Users, X, Smile } from "react-feather";
import { Info, Activity, FolderOpen, User } from "lucide-react";
import { Link } from "react-router-dom";
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledTooltip } from "reactstrap";
import { ticketPriorityIcons } from "../../../../config/constants";
import { Activities } from "../../../components/Activities";
import { BlurSpinner } from "../../../components/BlurSpinner";
import Filemanager from "../../../components/FileManager";
import { StyledSelect } from "../../../components/StyledSelect";
import { useAuth } from "../../../context/AuthContext";
import useFetcher from "../../../hooks/useFetcher";
import useMutter from "../../../hooks/useMutter";
import modulos from "../../../mocks/modulos";
import { fetchPiAsignable, patchTicketing } from "../../../services/ticketingServices";
import { patchContactoCanal } from "../../../services/contactoCanal";
import DerivarModal from "../DerivarModal";
import MotivoModal from "../MotivoModal";
import SolucionModal from "../SolucionModal";
import { ContactoModal } from "../contactoModal";
import RatingScaleModal from "../ratingScaleModal";
import WatchersModal from "../WatchersModal";

export function getFaceIconNameAndColorByRating(rating) {
  switch (rating) {
    case 0:
      return { iconName: "fa-regular fa-face-meh", iconColor: "grey" };
    case 1:
      return { iconName: "fa-regular fa-face-angry", iconColor: "#e82e2e" };
    case 2:
      return { iconName: "fa-regular fa-face-frown", iconColor: "orange" };
    case 3:
      return { iconName: "fa-regular fa-face-smile", iconColor: "lightgreen" };
    case 4:
      return { iconName: "fa-regular fa-face-smile-beam", iconColor: "green" };
    default:
      return { iconName: "", iconColor: "" };
  }
}

const Tabs = ({ ticket, ticketId, setTicketState, location, history, activityComponent, ticketingCategories, isAudit, loadTicket }) => {
  const { currentUser, haveSucursalCasaCentralAsignada } = useAuth();
  const [activeTab, setActiveTab] = useState("1");
  const [piAsignable, isLoadingPis, , , reloadPiAsignable] = useFetcher(fetchPiAsignable, [ticketId]);
  const [modifyingStatus, setModifyingStatus] = useState(false);
  const [modifyingPriority, setModifyingPriority] = useState(false);
  const [personalInternoAsignado, setPersonalInternoAsignado] = useState(ticket.personalInternoAsignado);
  const [saveTicketCall, isSavingTicket] = useMutter(patchTicketing);
  // eslint-disable-next-line no-unused-vars
  const [saveContactoCanalCall, isSavingContactoCanal] = useMutter(patchContactoCanal);
  const [chargingDerivacion, setChargingDerivacion] = useState(false);
  const [modifyingSolucion, setModifyingSolucion] = useState(false);
  const [modifyingAsignado, setModifyingAsignado] = useState(false);
  const [modifyingMotivo, setModifyingMotivo] = useState(false);
  const [modifyClient, setModifyClient] = useState(false);
  const [modifyingWatchers, setModifyingWatchers] = useState(false);
  const contacto = ticket.CreadoPara;

  // eslint-disable-next-line prefer-const
  let [status, setStatus] = useState(ticket.status);
  const [prioridad, setPrioridad] = useState(ticket.prioridad);
  const isContactoCanal = ticket && ticket.creadoParaContactosCanales;
  const currentUserId = currentUser && currentUser.user.Pi.itemId;
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.TICKETING);
  const isOwner = ticket.personalInternoAsignado === currentUserId;
  const isWatcher = ticket && ticket.Watchers && ticket.Watchers.map((watcher) => watcher.itemId).includes(currentUserId);
  const isTeam = ticket && ticket.SucursaldepartamentoAsignado && haveSucursalCasaCentralAsignada(ticket.SucursaldepartamentoAsignado.itemId);
  const colaboradores = (ticket && ticket.Colaboradores) || [];
  const isColaborador = colaboradores.map((colaborador) => colaborador.itemId).includes(currentUserId);
  const canModifyStatus = ticket.editable && (isOwner || isWatcher || isAdmin || isTeam) && !isAudit;
  const canModifyPriority = ticket.editable && (isOwner || isWatcher || isAdmin || isTeam) && !isAudit;
  const canAsign = ticket.editable && (isOwner || isWatcher || isAdmin || isTeam) && !isAudit;
  const canEditMotivoAndSubMotivo = ticket.editable && (isOwner || isWatcher || isAdmin || isTeam) && !isAudit;
  // condiciones para la valoracion de la respuesta del ticket
  const isSolicitante = (currentUser && currentUser.user && currentUser.user.email) === (ticket && ticket.CreadoPara && ticket.CreadoPara.email2);
  const isCerrado = ticket && ticket.status === 3;
  const isValorado = ticket && ticket.valoracion !== null;
  const [valoracion, setValoracion] = useState(null);

  const canRate = isSolicitante && isCerrado && !isValorado;

  const [showRatingScaleModal, setShowRatingScaleModal] = useState(canRate);
  useEffect(() => {
    setShowRatingScaleModal(canRate);
  }, [ticket.ticketId]);

  useEffect(() => {
    setValoracion(ticketingCategories && ticketingCategories.valoraciones && ticketingCategories.valoraciones.find((item) => item.id === ticket.valoracion));
  }, [ticket]);

  const { iconName, iconColor } = getFaceIconNameAndColorByRating(valoracion ? valoracion.id : null);

  const canComment = ticket.editable && (isOwner || isAdmin || isTeam || isColaborador) && !isAudit;
  const canUpload = ticket.editable && (isOwner || isAdmin || isTeam || isColaborador) && !isAudit;
  const isAsociado = ticket && ticket.creadoParaAsociados !== null;
  const isClient = isAsociado ? false : ticket.CreadoPara.categoriaCat && ticket.CreadoPara.categoriaCat.text === "Cliente";
  const isExAsociado = contacto && contacto.categoriaCat && contacto.categoriaCat.text === "Ex-Asociado";
  const piAsignableOptions = piAsignable
    ? piAsignable
        .map((item) => {
          return { label: item.nombreApellido, value: item.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const permiso = currentUser.getPermiso(modulos.TICKETING);
  const permisoCat = permiso ? permiso.permisoCat.text : null;

  const statusOptions = ticketingCategories.status
    ? ticketingCategories.status
        .map((item) => {
          return { label: item.text, value: item.id };
        })
        .sort((a, b) => (a.label > b.label || a.label === "Cerrado" ? 1 : -1))
    : [];

  const filteredStatusOptions = permisoCat === "Member" ? statusOptions.filter((item) => item.value !== 3) : statusOptions;
  const prioridadOptions = ticketingCategories.prioridad
    ? ticketingCategories.prioridad
        .map((item) => {
          return { label: item.text, value: item.id };
        })
        .sort((a, b) => (a.label > b.label || a.label === "Baja" ? 1 : -1))
    : [];
  const setTicket = async (ticketData) => {
    setTicketState(ticketData);
    const refreshLocation = { ...location };
    refreshLocation.state.ticket = ticketData;
    history.replace(refreshLocation);
    setModifyingStatus(false);
    setModifyingPriority(false);
    setModifyingAsignado(false);
    setChargingDerivacion(false);
    setModifyingMotivo(false);
    setModifyingSolucion(false);
    setModifyClient(false);
    activityComponent.current.refreshActivities();
  };
  const handleTicketSave = async (newData, options) => {
    const [result, err] = await saveTicketCall([ticketId, newData], options);
    if (result) {
      setTicket(result);
      reloadPiAsignable();
    }
    if (err) {
      throw err;
    }
    return result;
  };

  const handleContactoCanalSave = async (itemId, newData, options) => {
    await saveContactoCanalCall([itemId, newData], options);
    await handleTicketSave([newData], options);
  };

  const handleTicketCancel = async () => {
    setModifyingStatus(false);
    setModifyingAsignado(false);
    setPersonalInternoAsignado(ticket.personalInternoAsignado);
  };

  const handleStatusChange = async (selected) => {
    status = selected.value;
    setStatus(status);
    try {
      await handleTicketSave({ status: selected.value });
    } catch (err) {
      setStatus(ticket.status);
    }
  };

  const handlePrioridadChange = async (selected) => {
    setPrioridad(selected.value);
    try {
      await handleTicketSave({ prioridad: selected.value });
    } catch (err) {
      setPrioridad(ticket.prioridad);
    }
  };

  const handleFilesChange = () => {
    activityComponent.current.refreshActivities();
  };

  return (
    <>
      {modifyingSolucion ? (
        <SolucionModal ticket={ticket} isSavingTicket={isSavingTicket} handleTicketSave={handleTicketSave} toggle={() => setModifyingSolucion(!modifyingSolucion)} />
      ) : null}
      {chargingDerivacion ? (
        <DerivarModal ticket={ticket} isSavingTicket={isSavingTicket} handleTicketSave={handleTicketSave} toggle={() => setChargingDerivacion(!chargingDerivacion)} />
      ) : null}
      {modifyingMotivo ? (
        <MotivoModal ticket={ticket} isSavingTicket={isSavingTicket} handleTicketSave={handleTicketSave} toggle={() => setModifyingMotivo(!modifyingMotivo)} />
      ) : null}
      {modifyClient ? (
        <ContactoModal
          ticket={ticket}
          isSavingContactoCanal={isSavingContactoCanal}
          handleContactoCanalSave={handleContactoCanalSave}
          toggle={() => setModifyClient(!modifyClient)}
          ticketingCategories={ticketingCategories}
        />
      ) : null}
      {showRatingScaleModal ? (
        <RatingScaleModal
          isOpen={showRatingScaleModal}
          ticket={ticket}
          handleTicketSave={handleTicketSave}
          toggle={() => setShowRatingScaleModal(!showRatingScaleModal)}
        />
      ) : null}
      <Nav tabs className="border-tab  justify-content-between mb-2" style={{ borderBottom: "none" }}>
        <NavItem className="nav mx-1 w-100" role="tablist">
          <NavLink className={`${activeTab === "1" ? "active" : ""} px-1 w-100`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("1")}>
            <span>
              <Info size={16} />
            </span>
            <small style={{ fontSize: "12px", fontFamily: "Nunito", fontWeight: "bold" }}>Estado</small>
          </NavLink>
        </NavItem>
        <NavItem className="nav w-100 mx-1" role="tablist">
          <NavLink className={`${activeTab === "2" ? "active" : ""} px-1 w-100`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("2")}>
            <span>
              <Activity size={16} />
            </span>
            <small style={{ fontSize: "12px", fontFamily: "Nunito", fontWeight: "bold" }}>Actividad </small>
          </NavLink>
        </NavItem>
        <NavItem className="nav w-100 mx-1" role="tablist">
          <NavLink className={`${activeTab === "3" ? "active" : ""} px-1 w-100`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("3")}>
            <span>
              <User size={16} />
            </span>
            <small style={{ fontSize: "12px", fontFamily: "Nunito", fontWeight: "bold" }}>Contacto</small>
          </NavLink>
        </NavItem>
        <NavItem className="nav w-100 mx-1" role="tablist">
          <NavLink className={`${activeTab === "4" ? "active" : ""} px-1 w-100`} style={{ display: "grid", cursor: "pointer" }} onClick={() => setActiveTab("4")}>
            <span>
              <FolderOpen size={16} />
            </span>
            <small style={{ fontSize: "12px", fontFamily: "Nunito", fontWeight: "bold" }}>Archivos</small>
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="p-0">
        <BlurSpinner isLoading={isLoadingPis || isSavingTicket}>
          <TabPane tabId="1" className="p-2">
            <Row>
              <div className="col-6 p-0">
                <div className="text-center py-1">
                  {modifyingStatus ? (
                    <>
                      <Button className="p-0 m-0" size="xs" color="link" onClick={() => setModifyingStatus(!modifyingStatus)}>
                        <X size="24" color="var(--secondary)" />
                      </Button>
                      <StyledSelect
                        name="status"
                        options={filteredStatusOptions}
                        onChange={handleStatusChange}
                        value={statusOptions.find((option) => {
                          return option.value === status;
                        })}
                      />
                    </>
                  ) : (
                    <>
                      {canModifyStatus ? (
                        <>
                          <Button className="p-0 m-0" id="btnModifyingStatus" size="xs" color="link" onClick={() => setModifyingStatus(!modifyingStatus)}>
                            <Edit size="24" color="var(--secondary)" />
                          </Button>
                          <UncontrolledTooltip placement="top" target="btnModifyingStatus">
                            Cambiar estado
                          </UncontrolledTooltip>
                        </>
                      ) : (
                        <Lock
                          size="24"
                          style={{
                            color: `#${ticket.statusCat ? ticket.statusCat.color : "fff"}`,
                          }}
                        />
                      )}
                      <h4>
                        <span
                          className="badge"
                          style={{
                            fontSize: "18",
                            background: `#${ticket.statusCat ? ticket.statusCat.color : "fff"}`,
                          }}
                        >
                          {ticket.statusCat ? ticket.statusCat.text : ""}
                          {ticket.vencido === 1 ? (
                            <>
                              <br />
                              (Vencido)
                            </>
                          ) : null}
                        </span>
                      </h4>
                    </>
                  )}
                </div>
              </div>
              <div className="col-6 p-0">
                <div className="text-center py-1">
                  {modifyingPriority ? (
                    <>
                      <Button className="p-0 m-0" size="xs" color="link" onClick={() => setModifyingPriority(!modifyingPriority)}>
                        <X size="24" color="var(--secondary)" />
                      </Button>
                      <StyledSelect
                        name="status"
                        options={prioridadOptions}
                        onChange={handlePrioridadChange}
                        value={prioridadOptions.find((option) => {
                          return option.value === prioridad;
                        })}
                      />
                    </>
                  ) : (
                    <>
                      {canModifyPriority ? (
                        <>
                          <Button className="p-0 m-0" id="btnModifyingPriority" size="xs" color="link" onClick={() => setModifyingPriority(!modifyingPriority)}>
                            {ticket.prioridadCat && ticketPriorityIcons[ticket.prioridadCat.text]
                              ? React.createElement(ticketPriorityIcons[ticket.prioridadCat.text], {
                                  size: "24",
                                  style: {
                                    color: "var(--secondary)",
                                  },
                                })
                              : React.createElement(ticketPriorityIcons.default, {
                                  size: "24",
                                  style: {
                                    color: "var(--secondary)",
                                  },
                                })}
                          </Button>
                          <UncontrolledTooltip placement="top" target="btnModifyingPriority">
                            Cambiar prioridad
                          </UncontrolledTooltip>
                        </>
                      ) : (
                        <Lock
                          size="24"
                          style={{
                            color: `#${ticket.statusCat ? ticket.statusCat.color : "fff"}`,
                          }}
                        />
                      )}
                      <h4>
                        <span
                          className="badge"
                          style={{
                            fontSize: "18",
                            background: `#${ticket.prioridadCat ? ticket.prioridadCat.color : "eee"}`,
                          }}
                        >
                          Prioridad
                          {ticket.prioridadCat && (
                            <>
                              <br />
                              {ticket.prioridadCat.text}
                            </>
                          )}
                        </span>
                      </h4>
                    </>
                  )}
                </div>
              </div>
            </Row>
            <Row>
              <Col>
                <div className="mb-0">
                  <div className="py-3 pr-2 custom-scrollbar" style={{ height: "calc(100vh - 400px)", minHeight: "320px", overflowY: "auto" }}>
                    <div className="text-muted">Asignado a: </div>
                    <div className="d-flex justify-content-between align-items-center">
                      {modifyingAsignado ? (
                        <>
                          <StyledSelect
                            className="w-75"
                            name="personalInternoAsignado"
                            options={piAsignableOptions}
                            onChange={(selected) => setPersonalInternoAsignado(selected.value)}
                            value={piAsignableOptions.find((option) => {
                              return option.value === personalInternoAsignado;
                            })}
                          />
                          <div>
                            <Button size="xs" color="link" onClick={() => handleTicketSave({ personalInternoAsignado })}>
                              <Save size="24" color="var(--secondary)" />
                            </Button>
                            <Button size="xs" color="link" onClick={handleTicketCancel}>
                              <X size="24" color="var(--secondary)" />
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          {ticket.PersonalInternoAsignado ? ticket.PersonalInternoAsignado.nombreApellido : "-"}
                          {canAsign ? (
                            <div>
                              <Button size="xs" id="btnModifyingAsignado" color="link" onClick={() => setModifyingAsignado(!modifyingAsignado)}>
                                <Edit size="24" color="var(--secondary)" />
                              </Button>
                              <UncontrolledTooltip placement="top" target="btnModifyingAsignado">
                                Reasignar
                              </UncontrolledTooltip>
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>

                    <hr className="my-2" />
                    <div className="text-muted">Watchers: </div>
                    <div className="d-flex justify-content-between align-items-center">
                      {modifyingWatchers ? (
                        <WatchersModal
                          isAdmin={isAdmin}
                          ticketId={ticketId}
                          isOpen={modifyingWatchers}
                          watchers={ticket.Watchers}
                          toggle={() => setModifyingWatchers(!modifyingWatchers)}
                          loadTicket={loadTicket}
                          piAsignableOptions={piAsignableOptions}
                        />
                      ) : (
                        <>
                          {ticket.Watchers && ticket.Watchers.length > 0 ? (
                            <div className="d-flex flex-wrap gap-1">
                              {ticket.Watchers.map((item) => {
                                return (
                                  <div className="border rounded" style={{ padding: "2px 5px", background: "#e9e8e8", margin: "2px" }}>
                                    {item.nombreApellido}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            "-"
                          )}
                          {canAsign ? (
                            <div>
                              <Button size="xs" id="btnModifyingWatchers" color="link" onClick={() => setModifyingWatchers(!modifyingWatchers)}>
                                <Edit size="24" color="var(--secondary)" />
                              </Button>
                              <UncontrolledTooltip placement="top" target="btnModifyingWatchers">
                                Modificar watchers
                              </UncontrolledTooltip>
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>

                    <hr className="my-2" />
                    {ticket.SucursaldepartamentoAsignadoSucursales ? (
                      <>
                        <div className="text-muted">Sector: </div>
                        <div className="d-flex justify-content-between align-items-center">
                          Operación
                          {canAsign ? (
                            <div>
                              <Button size="xs" id="btnChargingDerivacion" color="link" onClick={() => setChargingDerivacion(!chargingDerivacion)}>
                                <FontAwesomeIcon icon={faShare} size="2x" color="var(--secondary)" />
                              </Button>
                              <UncontrolledTooltip placement="top" target="btnChargingDerivacion">
                                Derivar caso
                              </UncontrolledTooltip>
                            </div>
                          ) : null}
                        </div>
                        <hr className="my-2" />
                        <div className="text-muted">Sucursal / Departamento: </div>
                        <div>{ticket.SucursaldepartamentoAsignadoSucursales.titulo}</div>
                        <hr className="my-2" />
                      </>
                    ) : (
                      <></>
                    )}
                    {ticket.SucursaldepartamentoAsignadoCasaCentral ? (
                      <>
                        <div className="text-muted">Sector: </div>
                        <div className="d-flex justify-content-between align-items-center">
                          Casa Central
                          {canAsign ? (
                            <div>
                              <Button size="xs" id="btnChargingDerivacion" color="link" onClick={() => setChargingDerivacion(!chargingDerivacion)}>
                                <FontAwesomeIcon icon={faShare} size="2x" color="var(--secondary)" />
                              </Button>
                              <UncontrolledTooltip placement="top" target="btnChargingDerivacion">
                                Derivar caso
                              </UncontrolledTooltip>
                            </div>
                          ) : null}
                        </div>
                        <hr className="my-2" />
                        <div className="text-muted">Sucursal / Departamento: </div>
                        <div>{ticket.SucursaldepartamentoAsignadoCasaCentral.title}</div>
                        <hr className="my-2" />
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="text-muted">Motivo: </div>
                    <div className="d-flex justify-content-between align-items-center ">
                      <div>{ticket.Motivo2 ? ticket.Motivo2.titulo : "-"}</div>
                      {canEditMotivoAndSubMotivo ? (
                        <div>
                          <Button size="xs" id="btnModifyingMotivo" color="link" onClick={() => setModifyingMotivo(!modifyingMotivo)}>
                            <Edit size="24" color="var(--secondary)" />
                          </Button>
                          <UncontrolledTooltip placement="top" target="btnModifyingMotivo">
                            Cambiar Motivo/Submotivo
                          </UncontrolledTooltip>
                        </div>
                      ) : null}
                    </div>
                    <div className="text-muted">Sub-Motivo: </div>
                    <div
                      className="badge"
                      style={{
                        fontSize: "unset",
                        background: `#${ticket.Submotivo && ticket.Submotivo.prioridadCat ? ticket.Submotivo.prioridadCat.color : "fff"}`,
                      }}
                    >
                      {ticket.Submotivo ? ticket.Submotivo.title : "-"}
                    </div>
                    <hr className="my-2" />
                    <div className="text-muted">Valoración: </div>
                    <div className="d-flex justify-content-between align-items-center ">
                      <div>{valoracion ? valoracion.label : "-"}</div>
                      {canRate ? (
                        <div>
                          <Button size="xs" id="btnValorar" color="link" onClick={() => setShowRatingScaleModal(!showRatingScaleModal)}>
                            <Smile size="24" color="var(--secondary)" />
                          </Button>
                          <UncontrolledTooltip placement="top" target="btnValorar">
                            Valorar Respuesta
                          </UncontrolledTooltip>
                        </div>
                      ) : (
                        valoracion && <FontAwesomeIcon color={iconColor} size="2x" icon={iconName} />
                      )}
                    </div>
                    <div className="text-muted">Comentario: </div>

                    {ticket.valoracionComentario ? ticket.valoracionComentario : "-"}
                    <hr className="my-2" />
                  </div>
                </div>
              </Col>
            </Row>
          </TabPane>
        </BlurSpinner>
        <TabPane tabId="2">
          <Activities
            ref={activityComponent}
            bodyStyle={{ overflow: "auto", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px" }}
            entityId={ticketId}
            entity="ticketing"
            editable={canComment}
            hideHeader
          />
        </TabPane>
        <TabPane tabId="3">
          <div className="user-profile">
            <Col className="px-2">
              <div className="mb-0">
                <div className="py-3 custom-scrollbar" style={{ height: "calc(100vh - 300px)", minHeight: "400px", overflowY: "auto" }}>
                  <div className="text-muted">Nombre y apellido: </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>{(contacto && (contacto.nombreApellido || contacto.razonSocial || `${contacto.nombre} ${contacto.apellido}`)) || "-"}</div>
                    {isContactoCanal && !isAudit ? (
                      <div>
                        <Button size="xs" id="btnModifyingContact" color="link" onClick={() => setModifyClient(!modifyClient)} disabled={!isAudit}>
                          <Edit size="20" />
                        </Button>

                        <UncontrolledTooltip placement="top" target="btnModifyingContact">
                          Modificar Contacto
                        </UncontrolledTooltip>
                      </div>
                    ) : null}
                  </div>
                  {isClient ? (
                    <>
                      <hr className="my-2" />
                      <div className="text-muted">CUIL: </div>
                      <div>{(contacto && (contacto.cuil || contacto.cuit || contacto.cuit)) || "-"}</div>
                    </>
                  ) : (
                    <>
                      <hr className="my-2" />
                      <div id="dniCamp">
                        <div className="text-muted">DNI / CUIL:</div>
                        <div>
                          {(contacto && contacto.dni && contacto.dni.replace(".0000", "")) || "-"} /{" "}
                          {(contacto && (contacto.cuil || contacto.cuit || contacto.cuit)) || " -"}
                        </div>
                        {/* <UncontrolledTooltip placement="top" target="dniCamp">
                          CUIL: {(contacto && (contacto.cuil || contacto.dnicuilcuit || contacto.cuit)) || "-"}
                        </UncontrolledTooltip> */}
                      </div>
                    </>
                  )}
                  <hr className="my-2" />
                  <div className="text-muted">Email: </div>
                  <div>{(contacto && (contacto.email2 || contacto.titulo || contacto.title)) || "-"}</div>
                  <hr className="my-2" />
                  <div className="text-muted">Telefono: </div>
                  <div>{(contacto && contacto.telefono) || "-"}</div>
                  <hr className="my-2" />
                  <div className="text-muted">Sucursal: </div>
                  <div>{(contacto && contacto.sucursalText) || "-"}</div>
                  <hr className="my-2" />
                  <div className="text-muted">Cliente: </div>
                  <div>{(contacto && contacto.cliente2) || "-"}</div>
                  <hr className="my-2" />
                  <div className="text-muted">Canal: </div>
                  <div
                    className="badge"
                    style={{
                      fontSize: "unset",
                      background: `#${ticket.canal && ticket.canalCat ? ticket.canalCat.color : "fff"}`,
                    }}
                  >
                    <Radio size="24" /> {ticket.canalCat ? ticket.canalCat.text : "-"}
                  </div>
                  <hr className="my-2" />
                  <div className="text-muted">Público: </div>
                  {isExAsociado ? (
                    <div
                      className="badge"
                      style={{
                        fontSize: "unset",
                        background: `#F7D1D0`,
                      }}
                    >
                      <Users size="24" /> Asociado
                    </div>
                  ) : (
                    <div
                      className="badge"
                      style={{
                        fontSize: "unset",
                        background: `#${contacto ? (contacto.categoriaCat ? contacto.categoriaCat.color : ticket.categoriaCat.color) : "fff"}`,
                      }}
                    >
                      <Users size="24" /> {contacto ? (contacto.categoriaCat ? contacto.categoriaCat.text : ticket.categoriaCat.text) : "-"}
                    </div>
                  )}
                  <hr className="my-2" />
                  <div className="text-muted">Mas tickets de este contacto: </div>
                  <div>
                    <Link
                      style={{ color: "var(--secondary)" }}
                      to={{
                        pathname: "/ticketing",
                        search: `?mode=creador&creadoPara=${contacto && contacto.itemId}&creadoParaName=${
                          (contacto && (contacto.nombreApellido || contacto.razonSocial || `${contacto.nombre} ${contacto.apellido}`)) || "-"
                        }`,
                        state: {
                          from: location,
                        },
                      }}
                    >
                      Ver Tickets
                    </Link>
                  </div>
                  <hr className="my-2" />
                </div>
              </div>
            </Col>
          </div>
        </TabPane>
        <TabPane tabId="4">
          <Filemanager
            bodyStyle={{ overflow: "auto", paddingLeft: "10px", paddingRight: "10px", paddingTop: "10px" }}
            fileNameStyle={{ fontSize: "14px", fontWeight: "300" }}
            entityId={ticketId}
            entity="ticketing"
            onChange={handleFilesChange}
            editable={canUpload}
            hideHeader
          />
        </TabPane>
      </TabContent>
    </>
  );
};

export default Tabs;
